import axios from 'axios'

const apiClient = axios.create({
    baseURL: `https://micro-promo-campaign.wm.r.appspot.com`,
    withCredentials: false, // This is the default
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
})

export default {
    getPromos() {
        return apiClient.get('/promo/active')
    },
    postPromo(body) {
        return apiClient.post("/notification", body)
    }
}